if (!customElements.get('product-gift-progress')) {
  class ProductGiftProgress extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.threshold = Number(this.dataset.threshold || 5000);

      this.render(Number(this.dataset.initialTotal || 0));
      this.refresh();

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refreshBurst());
      }

      this.handleCartInteraction = (event) => {
        const cartForm = event.target?.closest?.('form[action*="/cart"]');
        const cartControl = event.target?.closest?.('cart-remove-button, [name="updates[]"], [data-cart-add], [name="add"]');
        if (cartForm || cartControl) this.refreshBurst();
      };
      document.addEventListener('submit', this.handleCartInteraction, true);
      document.addEventListener('change', this.handleCartInteraction, true);
      document.addEventListener('click', this.handleCartInteraction, true);

      this.handlePageShow = () => this.refresh();
      this.handleVisibility = () => {
        if (!document.hidden) this.refresh();
      };
      window.addEventListener('pageshow', this.handlePageShow);
      document.addEventListener('visibilitychange', this.handleVisibility);

      if ('PerformanceObserver' in window) {
        this.resourceObserver = new PerformanceObserver((list) => {
          const cartChanged = list.getEntries().some((entry) =>
            /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(entry.name)
          );
          if (cartChanged) this.refreshBurst();
        });
        this.resourceObserver.observe({ type: 'resource', buffered: true });
      }
    }

    disconnectedCallback() {
      this.unsubscribe?.();
      this.resourceObserver?.disconnect();
      document.removeEventListener('submit', this.handleCartInteraction, true);
      document.removeEventListener('change', this.handleCartInteraction, true);
      document.removeEventListener('click', this.handleCartInteraction, true);
      document.removeEventListener('visibilitychange', this.handleVisibility);
      window.removeEventListener('pageshow', this.handlePageShow);
      this.refreshTimers?.forEach((timer) => clearTimeout(timer));
    }

    refreshBurst() {
      this.refreshTimers?.forEach((timer) => clearTimeout(timer));
      this.refreshTimers = [120, 650, 1600].map((delay) => setTimeout(() => this.refresh(), delay));
    }

    async refresh() {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          cache: 'no-store'
        });
        if (!response.ok) return;
        const cart = await response.json();
        const eligibleTotal = (cart.items || []).reduce((total, item) => {
          const handle = String(item.handle || '').toLowerCase();
          const type = String(item.product_type || '').toLowerCase();
          const title = String(item.product_title || item.title || '').toLowerCase();
          const isGiftCard = Boolean(item.gift_card) || handle.includes('gift-card') || type.includes('gift card') || title.includes('gift card');
          return isGiftCard ? total : total + Number(item.final_line_price || 0);
        }, 0);
        this.render(eligibleTotal);
      } catch (error) {
        // Keep the server-rendered state when the cart endpoint is unavailable.
      }
    }

    money(cents) {
      return new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2
      }).format(cents / 100);
    }

    render(total) {
      const unlocked = total >= this.threshold;
      const percentage = Math.max(0, Math.min(100, (total / this.threshold) * 100));
      const message = this.querySelector('[data-progress-message]');

      if (message) {
        if (unlocked) {
          message.textContent = this.dataset.completeMessage;
        } else {
          const remaining = this.threshold - total;
          message.textContent = this.dataset.beforeMessage.replace('__AMOUNT__', this.money(Math.max(0, remaining)));
        }
      }

      this.querySelector('[data-progress-fill]')?.style.setProperty('width', `${percentage}%`);
      this.querySelector('[data-progress-track]')?.setAttribute('aria-valuenow', String(Math.min(50, Math.round(total / 100))));
      this.querySelector('[data-milestone]')?.classList.toggle('is-unlocked', unlocked);
      this.classList.toggle('is-unlocked', unlocked);
    }
  }

  customElements.define('product-gift-progress', ProductGiftProgress);
}
